import { registerSettingsCard } from '../../components/SettingsCards';
import type { SettingsCardProps } from '../../components/SettingsCards';
import { SettingsEditor } from '../../components/SettingsEditor';
import { IdChecksGroupCard } from './IdChecks';
import { GroupLanguageCard, SiteLanguagesCard } from './Languages';

/**
 * Settings cards on the site and group pages. The pages draw one section per module (SettingsCards looks a card up by module
 * key). `core` carries the visitor language settings (I1), `id-checks` the group ID check card. Where a module has no custom
 * card for a level, the generic settings form is kept.
 */
registerSettingsCard('core', function CoreScopedCard(props: SettingsCardProps) {
  return props.scope === 'sites' ? <SiteLanguagesCard {...props} /> : <GroupLanguageCard {...props} />;
});

registerSettingsCard('id-checks', function IdChecksScopedCard(props: SettingsCardProps) {
  if (props.scope === 'groups') return <IdChecksGroupCard {...props} />;
  return <SettingsEditor moduleKey={props.moduleKey} base={`/${props.scope}/${props.scopeId}/settings`} canEdit={props.canEdit} />;
});
